import { render, staticRenderFns } from "./view-product.vue?vue&type=template&id=2dac3051&scoped=true&"
import script from "./view-product.vue?vue&type=script&lang=js&"
export * from "./view-product.vue?vue&type=script&lang=js&"
import style0 from "./view-product.vue?vue&type=style&index=0&id=2dac3051&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dac3051",
  null
  
)

export default component.exports